import { NgModule, ModuleWithProviders } from '@angular/core';
import { AtlasMapComponent } from './components/atlas-map/atlas-map.component';
import { MapLoaderService } from './services';
import { AtlasPopupDirective } from './directives/atlas-popup/atlas-popup.directive';

@NgModule({
  declarations: [AtlasMapComponent, AtlasPopupDirective],
  imports: [
  ],
  exports: [AtlasMapComponent, AtlasPopupDirective]
})
export class AngularAzureAtlasModule {
  public static forRoot(): ModuleWithProviders {
    return  {
      ngModule: AngularAzureAtlasModule,
      providers: [
        MapLoaderService
      ]
    }
  }
}
